import { render, staticRenderFns } from "./ProductShipOptions.vue?vue&type=template&id=0c96c324&scoped=true&lang=pug&"
import script from "./ProductShipOptions.vue?vue&type=script&lang=js&"
export * from "./ProductShipOptions.vue?vue&type=script&lang=js&"
import style0 from "./ProductShipOptions.vue?vue&type=style&index=0&id=0c96c324&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c96c324",
  null
  
)

export default component.exports